<template>
  <div class="subscription-items">
    <div class="subscription-items__header">
      <span class="subscription-items__header__title">{{
        $t('ec-line009.subscriptionList.subscriptionId', { id: data.index })
      }}</span>
      <span>
        <span class="subscription-items__header__sub-title">{{ subTitle }}</span>
      </span>
    </div>
    <div class="subscription-items__list" v-for="item in data.subscription_order_item" :key="item.id">
      <div class="subscription-items__list__card">
        <!-- <div class="w-14 lg:w-24"> -->
        <img :src="getImage(item)" class="subscription-items__list__card__image" />
        <!-- </div> -->
        <span class="subscription-items__list__card__name">{{ item.product_name }}</span>
      </div>
    </div>

    <div class="subscription-items__information">
      <div class="subscription-items__information__wrap">
        <label class="subscription-items__information__label">{{
          $t('ec-line009.subscriptionList.information.address')
        }}</label>
        <p class="subscription-items__information__value">{{ data.subs_address }}</p>
      </div>
      <div class="subscription-items__information__wrap">
        <label class="subscription-items__information__label">{{ $t('common.label.paymentMethod') }}</label>
        <p class="subscription-items__information__value">{{ data.payment_method }}</p>
      </div>
      <div class="subscription-items__information__wrap">
        <label class="subscription-items__information__label">{{ $t('common.label.deliveryPattern') }}</label>
        <p class="subscription-items__information__value">{{ subscriptionPattern }}</p>
      </div>
      <div class="subscription-items__information__wrap">
        <label class="subscription-items__information__label">{{ $t('common.label.deliveryTimezone') }}</label>
        <p class="subscription-items__information__value">{{ data.delivery_time }}</p>
      </div>
      <div class="subscription-items__information__wrap">
        <label class="subscription-items__information__label">{{ $t('common.label.lastDeliveryDate') }}</label>
        <p class="subscription-items__information__value">
          {{
            Utils.date.getDateString(
              data.delivery_date_lastest,
              Constants.FORMAT_DATE_JP_INCLUDE_DAY,
              $t('ec-line009.subscriptionList.information.noDelivery')
            )
          }}
        </p>
      </div>
      <template v-if="isRunning">
        <div class="subscription-items__information__wrap">
          <label class="subscription-items__information__label">{{ $t('common.label.nextDeliveryDate') }}</label>
          <p class="subscription-items__information__value">
            {{ Utils.date.getDateString(data.next_delivery_date, Constants.FORMAT_DATE_JP_INCLUDE_DAY) }}
          </p>
        </div>
        <div class="subscription-items__information__wrap">
          <label class="subscription-items__information__label">{{ $t('common.label.nextNextDelieveryDate') }}</label>
          <p class="subscription-items__information__value">
            {{ Utils.date.getDateString(data.next_next_delivery_date, Constants.FORMAT_DATE_JP_INCLUDE_DAY) }}
          </p>
        </div>
      </template>
      <template v-else>
        <div class="subscription-items__information__wrap">
          <label class="subscription-items__information__label">{{ $t('common.label.stopDate') }}</label>
          <p class="subscription-items__information__value">
            {{ Utils.date.getDateString(data.pause_date, Constants.FORMAT_DATE_JP_INCLUDE_DAY) }}
          </p>
        </div>
      </template>

      <el-button
        v-if="isLumpsumAndNotPauseTab"
        class="cart-subscription-item-list__total__button mt-2"
        size="mini"
        @click="showDeliveryDialog"
        >{{ $t('ec-line014.lumpsum.shopInfo.checkDeliveryDate') }}</el-button
      >
    </div>
    <p class="whitespace-pre-line text-base text-red-150 mt-2 lg:mt-3" v-if="isLumpsumAndNotPauseTab && isPaymentError">
      {{
        $t('ec-line009.subscriptionList.errormessagePayment', {
          date: Utils.date.getDateString(data.next_delivery_date, Constants.FORMAT_DATE),
        })
      }}
    </p>
    <inquiry-information v-if="isLumpsum" class="mt-5 mb-2.5" :is-pause-tab="isPauseTab" />
    <p
      class="whitespace-pre-line text-base text-red-150 mt-2 lg:mt-3"
      v-if="!isLumpsumAndNotPauseTab && isPaymentError && !isNDDGreaterThan9DateFromToday"
    >
      {{
        $t('ec-line009.subscriptionList.errorPaymentTemplate', {
          date: Utils.date.getDateString(data.next_delivery_date, Constants.FORMAT_DATE),
        })
      }}
    </p>
    <p
      class="whitespace-pre-line text-base text-red-150"
      v-if="
        !isLumpsumAndNotPauseTab && isPaymentError && !isNDDGreaterThan9DateFromToday && !data.is_payment_error_in_btc7
      "
    >
      {{ (!isDiffMinDay && $t('ec-line009.subscriptionList.nextDeliveryNote')) || '' }}
    </p>
    <div class="flex justify-center mt-2 lg:mt-3">
      <el-button
        v-if="!isLumpsum"
        class="submit-btn font-bold text-base lg:text-lg leading-normal"
        @click="handleSubmit(data.subscription_status_id)"
        >{{
          data.subscription_status_id === Constants.SUBSCRIPTION_STATUS.PAUSE
            ? $t('ec-line009.reopenButton')
            : isPaymentError && !isNDDGreaterThan9DateFromToday
            ? $t('ec-line014.cart.changePaymentBtn')
            : $t('ec-line009.subscriptionList.changePurchaseBtn')
        }}
      </el-button>
    </div>
    <el-dialog
      :visible="lumpsumDeliveryVisible"
      class="cart-subscription-item-list__delivery__dialog"
      v-loading="lumpsumLoading"
      fullscreen
      append-to-body
      destroy-on-close
      :show-close="false"
    >
      <my-page-layout>
        <div class="cart-subscription-item-list__delivery__dialog__content mx-4 mt-8 lg:mt-12">
          <div class="flex justify-between items-baseline">
            <h3>
              {{ $t('ec-line014.lumpsum.deliveryDialog.title', [data.index]) }}
            </h3>
            <div
              class="cart-subscription-item-list__delivery__dialog__content__close-button"
              @click="closeDeliveryDialog"
            >
              <img :src="require('@/assets/images/close-button.svg')" />
            </div>
          </div>

          <el-card class="cart-subscription-item-list__delivery__dialog__content__card" shadow="never">
            <div class="cart-subscription-item-list__delivery__dialog__content__card__body beauty-scrollbar">
              <el-row
                :gutter="24"
                v-for="(lumpsumDelivery, i) in lumpsumDeliveryData"
                :key="i"
                class="mt-7 flex items-center"
              >
                <el-col :span="12">
                  <p class="text-h4 text-right">
                    {{ $t('ec-line014.lumpsum.deliveryDialog.time', [i + 1]) }}
                  </p>
                </el-col>
                <el-col :span="12">
                  <p class="text-body-02 text-left">{{ $d(lumpsumDelivery.delivery_date, 'short') }}</p>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <div class="w-full mt-6 pb-6 flex justify-center">
            <el-button class="cancel-btn align-center" @click="closeDeliveryDialog">{{
              $t('common.action.cancel')
            }}</el-button>
          </div>
        </div>
      </my-page-layout>
    </el-dialog>
  </div>
</template>

<script>
import { ENV_KEY } from '@/constants/env'
import { addDays, isAfter, add, startOfDay } from 'date-fns'
import { SubscriptionService } from '@/services'
import MyPageLayout from '@/layouts/MyPageLayout.vue'
import InquiryInformation from './InquiryInformation.vue'
export default {
  components: {
    MyPageLayout,
    InquiryInformation,
  },
  name: 'SubscriptionItems',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isRunning: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      lumpsumDeliveryVisible: false,
      lumpsumLoading: false,
      lumpsumDeliveryData: [],
    }
  },

  computed: {
    subscriptionPattern() {
      const dayOfWeeks = Object.entries(this.Constants.DAY_OF_WEEK).map(([key, val]) => ({
        value: val,
        label: this.$t(`common.dayOfWeek.${this.$_.camelCase(key)}`),
      }))

      const text = {
        [this.Constants.DELIVERY_PATTERN_CHANGE.MONTHLY_DATE_SPECIFICATION]: this.$t(
          'ec-line014.cart.deliveryPatternInterval.monthlyDateSpecification',
          {
            param1: this.data.param1,
            param2: this.data.param2,
          }
        ),
        [this.Constants.DELIVERY_PATTERN_CHANGE.INTERVAL_DESIGNATION]: this.$t(
          'ec-line014.cart.deliveryPatternInterval.intervalDesignation',
          {
            param1: this.data.param1,
            param2: this.$t('common.weekNo', { week: this.data.param2 }),
            param3: dayOfWeeks.find((i) => i.value === this.data.param3)?.label || '',
          }
        ),
        [this.Constants.DELIVERY_PATTERN_CHANGE.SPECIFY_DELIVERY_DATE_INTERVAL]: this.$t(
          'ec-line014.cart.deliveryPatternInterval.specifyDeliveryDateInterval',
          { param1: this.data.param1 }
        ),
      }

      return text[this.data.subscription_division_id]
    },
    isDiffMinDay() {
      return isAfter(new Date(this.data.next_delivery_date), addDays(new Date(), 9))
    },
    subTitle() {
      return `${this.Utils.helper.formatCurrency(this.data.total)}`
    },
    isPauseTab() {
      return !this.isRunning
    },
    isLumpsum() {
      return this.data.lump_sum_payment_flag
    },
    isLumpsumAndNotPauseTab() {
      return !this.isPauseTab && this.isLumpsum
    },
    isPaymentError() {
      return !!this.data.code
    },
    isNDDGreaterThan9DateFromToday() {
      return isAfter(this.data.next_delivery_date, add(startOfDay(new Date()), 9))
    },
  },
  methods: {
    getImage(data) {
      return `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${data.product_image}`
    },
    handleSubmit(subscriptionStatus) {
      if (this.isPaymentError && (!this.isNDDGreaterThan9DateFromToday || this.isLumpsumAndNotPauseTab)) {
        this.toCpayPage()
      } else if (subscriptionStatus === this.Constants.SUBSCRIPTION_STATUS.PAUSE) {
        this.toDetailPage(this.Constants.LIST_SECTION.SUBSCRIPTION_SECTION)
      } else if (this.isPaymentError) {
        this.toDetailPage(this.Constants.LIST_SECTION.PAYMENT_SECTION)
      } else {
        this.toDetailPage(undefined)
      }
    },
    toCpayPage() {
      window.open(`${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/lpc/cpay?code=${this.data.code}`, '_blank')
    },
    toDetailPage(section) {
      this.$store.commit('subscription/UPDATE_SUBSCRIPTION')
      this.$store.commit('subscription/SET_SUBSCRIPTION_CONFIRM')
      this.$store.commit('subscription/SET_SUBSCRIPTION_NO', this.data.index)
      this.$router.push({
        name: 'EC_LINE015',
        params: { id: this.data.id },
        query: {
          section: section,
          index: this.data.index,
        },
      })
    },
    showDeliveryDialog() {
      this.lumpsumDeliveryVisible = true
      this.fetchLumpsumDeliveryDate()
    },
    closeDeliveryDialog() {
      this.lumpsumDeliveryVisible = false
    },
    fetchLumpsumDeliveryDate() {
      if (!this.data.id) {
        this.closeDeliveryDialog()
        return
      }

      this.lumpsumLoading = true

      SubscriptionService.getLumpsumDeliverydate(this.data.id)
        .then(({ data }) => (this.lumpsumDeliveryData = data))
        .finally(() => (this.lumpsumLoading = false))
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/ec-line009/subscription-items.scss';
@import '@/assets/css/components/ec-line014/cart-subscription-item-list.scss';
</style>
